module.exports = __webpack_public_path__ + "static/media/009.83008d1b.jpg";